import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axiosInstance from '../api';

const SNOOZE_KEY = 'mfaReminderSnoozedUntil';
const SNOOZE_DAYS = 7;

/**
 * Non-enforcing reminder to set up 2FA. Shows once MFA is confirmed-off for the user,
 * with a "Remind me later" that snoozes for 7 days (localStorage). Never blocks usage.
 */
function MfaReminderBanner() {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const snoozedUntil = Number(localStorage.getItem(SNOOZE_KEY) || 0);
    if (snoozedUntil && Date.now() < snoozedUntil) return;

    let active = true;
    axiosInstance.get('/mfa/status')
      .then(res => { if (active && res.data && res.data.enabled === false) setShow(true); })
      .catch(() => { /* best-effort; never block the dashboard */ });
    return () => { active = false; };
  }, []);

  if (!show) return null;

  const snooze = () => {
    localStorage.setItem(SNOOZE_KEY, String(Date.now() + SNOOZE_DAYS * 24 * 60 * 60 * 1000));
    setShow(false);
  };

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
      background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 10,
      padding: '12px 16px', margin: '0 0 16px',
    }}>
      <i className="fas fa-shield-alt" style={{ color: '#2563eb', fontSize: 18 }} />
      <span style={{ flex: 1, fontSize: 13, color: '#1e3a8a', minWidth: 220 }}>
        <strong>{t('MfaReminderBanner.secureAccountHeading')}</strong> {t('MfaReminderBanner.secureAccountDescription')}
      </span>
      <button
        onClick={() => navigate('/dashboard/settings', { state: { tab: 'security' } })}
        style={{
          background: '#2563eb', color: '#fff', border: 'none', borderRadius: 6,
          padding: '7px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer',
        }}>
        {t('MfaReminderBanner.setUp2faButton')}
      </button>
      <button onClick={snooze}
        style={{
          background: 'transparent', color: '#1e40af', border: '1px solid #bfdbfe',
          borderRadius: 6, padding: '7px 12px', fontSize: 13, cursor: 'pointer',
        }}>
        {t('MfaReminderBanner.remindLaterButton')}
      </button>
    </div>
  );
}

export default MfaReminderBanner;
